import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import FeedbackApi from './FeedbackApi';

let settings;

export default settings = {
    key: 'feedback',
    zone: 'users',
    path: '/feedback',
    title: "Feedback",
    endpoint: FeedbackApi.endpoint,
    modelName: 'Feedback',
    idKey: 'id',
    primaryKey: 'id',
    actions: ['trash', 'clone'],
    indexCaps: ["viewFeedback"],
    viewCaps: ["viewFeedback"],
    createCaps: ["createFeedback"],
    updateCaps: ["updateFeedback"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create",
            //     caps: settings.createCaps
            // },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            // {
            //     label: "Add New",
            //     path: settings.path + '/create',
            //     caps: settings.createCaps
            // }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: FeedbackApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['user'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "ID",
                key: "id",
                type: "text",
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "ID",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "User",
                key: "user",
                format: "ModelLink"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: FeedbackApi,
                settings: settings,
            }
        ];

        return columns;

    },
    indexExportFormats: (routeName, params, user) => {

        const formats = [
            { value: "feedbacks", label: "Feedbacks" }
        ];

        return formats;

    },
    singleFetch: FeedbackApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['user'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            // {
            //     label: "Edit",
            //     path: path + "/edit",
            //     caps: settings.updateCaps
            // },
        ]

    },
};